export const TipoSolicitud = Object.freeze({
  afiliacionpartido: 1,
  renunciapartido: 2,
  certificadoafiliacion: 3,
  certificadohistorico: 4,
  reclamo: 5
});
